var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.value
      ? _c("div", { staticClass: "spinner" }, [
          _c("div", { staticClass: "bounce1" }),
          _vm._v(" "),
          _c("div", { staticClass: "bounce2" }),
          _vm._v(" "),
          _c("div", { staticClass: "bounce3" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }